import React, {Fragment} from 'react'
import styles from './Units.scss'
import {Distance, Elevation, Grade, Speed} from 'common/units'
import {MetricUnitsContext} from 'common/units/MetricUnitsContext'

export class Units extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      metricUnits: false
    }
  }

  toggleMetricUnits = () => {
    this.setState({metricUnits: !this.state.metricUnits})
  }

  render () {
    const distance = 2345.6 // meters
    const grade = 463.8 / 100 // percentage, expressed in whole-number form (i.e 4.5 meters gain in 100 meters distance = 4.5)
    const speed = 123.45 // meters per second

    return (
      <MetricUnitsContext.Provider value={this.state.metricUnits}>
        <div className={styles.Units}>
          <h1>Units</h1>
          <p>
            There are some handy helpers in the <code>/src/common/units</code> module that are wrappers around methods from <a href='https://github.com/ridewithgps/rwgps-units'>rwgps-units</a>.  Below are some examples of different units and formattings.  A super cool thing about these components is that they are unstyled, and pull in the <code>metricUnits</code> from a React Context instead of a prop, so they should <strong>Just Work™</strong>.
          </p>
          <p>
            <label>
              <input type='checkbox' name='metricUnits' onChange={this.toggleMetricUnits} checked={this.state.metricUnits} style={{marginRight: 5}} />
              Metric units
            </label>
          </p>
          <h2>Distance</h2>
          <p>
            All of these distances will use the raw value of <code>{distance}</code><br />
            Default representation: <Distance value={distance} /><br />
            Force short units: <Distance value={distance} short /><br />
            Force small units: <Distance value={distance} smallUnits /><br />
            Force big units (with distance / 10): <Distance value={distance / 10} bigUnits /><br />
            Custom render prop: <Distance value={distance}>{unit => (
              <Fragment><strong>{unit.valueToString()}</strong> <em>{unit.long}</em></Fragment>
            )}</Distance>
          </p>
          <h2>Elevation</h2>
          <p>
            All of these elevations will use the raw value of <code>{distance}</code><br />
            Default representation: <Elevation value={distance} /><br />
            Force short units: <Elevation value={distance} short /><br />
            Force big units: <Elevation value={distance} bigUnits />
          </p>
          <h2>Grade</h2>
          <p>
            All of these grades will use the raw value of <code>{grade}</code><br />
            Default representation: <Grade value={grade} /><br />
            Force short units: <Grade value={grade} short /><br />
            {/* You need to set both maxFractionDigits and min when maxFractionDigits < 2, see https://github.com/andyearnshaw/Intl.js/issues/123#issuecomment-121196797 for context */}
            Force rounding: <Grade value={grade} short maximumFractionDigits={0} minimumFractionDigits={0} /><br />
            Force decimals: <Grade value={grade} short maximumFractionDigits={3} minimumFractionDigits={3} />
          </p>
          <h2>Speed</h2>
          All of these speeds will use the raw value of <code>{speed}</code><br />
          Default representation: <Speed value={grade} /><br />

        </div>
      </MetricUnitsContext.Provider>
    )
  }
}
